import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, postApi } from 'services/rotasp/api';
import { PATH_IIRGD_BU_PPT } from 'services/rotasp/path';

// ACTIONS
import { cadastroRgVincularDare } from 'store/modules/api/iirgd/cadastroRg/actions';

// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import { Types } from './types';

// ACTIONS
import {
	IRequestGerarDare,
	gerarDareSuccess,
	gerarDareFailure,
} from './actions';

function* gerarDareRequest(request: ReducerActionRotaSP) {
	const { token, payload }: { token?: string; payload: IRequestGerarDare } =
		request;

	const newPayload: any = { ...payload };

	delete newPayload.idCidadao;
	delete newPayload.usuario;
	delete newPayload.senha;

	const response: ApiResponse = yield call(
		postApi,
		token || '',
		PATH_IIRGD_BU_PPT,
		'dare',
		newPayload,
	);

	if (response.status === 201 || response.status === 200) {
		const { data } = response;

		yield put(gerarDareSuccess(data));
		yield put(cadastroRgVincularDare(data));
	} else if (response.error) {
		yield put(gerarDareFailure());
	}
}

export default all([takeLatest(Types.GERAR_DARE_REQUEST, gerarDareRequest)]);
